import React, { useState } from 'react'
import { Card, Row, Tree } from 'antd'
import { EmptyHeaderHero } from './components'
import { getDomain } from '../utils'

import SitemapStyle from '../../styles/Sitemap.module.css'

const treeData = [
  {
    title: 'CURE Auto Insurance',
    key: '0-0',
    children: [
      {
        title: 'Home',
        key: '0-0-0',
        href: '/'
      },
      {
        title: 'Why CURE',
        key: '0-0-1',
        href: '/why-cure'
      },
      {
        title: 'Claims Center',
        key: '0-0-2',
        href: '/claims'
      },
      {
        title: 'Roadside Assistance',
        key: '0-0-3',
        href: '/roadside'
      },
      {
        title: 'Direct Repair Shops',
        key: '0-0-4',
        href: '/find-repair-shops'
      },
      {
        title: 'News/Media',
        key: '0-0-5',
        href: '/news-media'
      },
      {
        title: 'Forms/Documents',
        key: '0-0-6',
        href: '/forms-and-documents'
      },
      {
        title: 'Terms & Conditions',
        key: '0-0-7',
        href: '/terms-conditions'
      },
      {
        title: 'Electronic Terms & Conditions',
        key: '0-0-8',
        href: '/electronic-terms-conditions'
      },
      {
        title: 'NAIC Numbers',
        key: '0-0-9',
        href: '/naic'
      },
      {
        title: 'Contact',
        key: '0-0-10',
        href: '/contact'
      },
      {
        title: 'Careers',
        key: '0-0-11',
        href: '/careers'
      },
      {
        title: 'Website Accessibility',
        key: '0-0-13',
        href: '/accessibility'
      },
      {
        title: 'My Account',
        key: '0-1-0',
        children: [
          {
            title: 'Log In',
            key: '0-1-1',
            href: '/my-account'
          },
          {
            title: 'Account Registration',
            key: '0-1-2',
            href: '/my-account/register'
          },
          {
            title: 'Online Payment',
            key: '0-1-3',
            href: 'https://' + getDomain('payments')
          },
          {
            title: 'Policy Documents',
            key: '0-1-4',
            href: '/my-account'
          },
          {
            title: 'Register for Paperless Billing',
            key: '0-1-5',
            href: '/my-account'
          },
          {
            title: 'Forgot Log In Information',
            key: '0-1-6',
            href: '/my-account/forgot-email'
          },
          {
            title: 'Security Statement',
            key: '0-1-7',
            href: '/security-policy'
          }
        ]
      },
      // {
      //   title: 'Manage Policy',
      //   key: '0-2-0',
      //   children: [
      //     {
      //       title: 'Express Policy Change',
      //       key: '0-2-1',
      //       href: '/g/express-policy-changes'
      //     }
      //   ]
      // },
      {
        title: 'Get a Quote',
        key: '0-3-0',
        children: [
          {
            title: 'Start Quote',
            key: '0-3-1',
            href: 'https://' + getDomain('quote') + '/default.aspx'
          },
          {
            title: 'Retrieve Quote',
            key: '0-3-2',
            href: 'https://' + getDomain('quote') + '/retrieve-saved-quote.aspx'
          }
        ]
      }
    ]
  }
]

const Sitemap = () => {
  const [expandedKeys, setExpandedKeys] = useState(['0-0'])

  const onSelect = (keys, info) => {
    const {
      node: { href, title }
    } = info ?? {}
    if (href) {
      window.location = href
    }
    if (keys.length > 0 && title !== 'CURE Auto Insurance') {
      setExpandedKeys(['0-0', ...keys])
    } else if (keys.length > 0 && title === 'CURE Auto Insurance' && !expandedKeys.includes('0-0')) {
      setExpandedKeys(['0-0'])
    } else if (keys.length > 0 && title === 'CURE Auto Insurance' && expandedKeys.includes('0-0')) {
      setExpandedKeys([])
    } else if (keys.length === 0 && title === 'CURE Auto Insurance' && expandedKeys.includes('0-0')) {
      setExpandedKeys([])
    } else {
      setExpandedKeys(['0-0'])
    }
  }

  return (
    <>
      <EmptyHeaderHero title="Sitemap" />
      <div className={`${SitemapStyle["sitemap-screen"]}`}>
        <Row>
          <Card className={`${SitemapStyle["sitemap-card"]}`}>
            <Tree
              defaultExpandAll
              expandedKeys={expandedKeys}
              onExpand={expanded => {
                setExpandedKeys([...expanded])
              }}
              onSelect={onSelect}
              treeData={treeData}
            />
          </Card>
        </Row>
      </div>
    </>
  )
}

Sitemap.propTypes = {}

export default Sitemap
